export const addCircleIconWhite = 'assets/icons/tui-plus-white.svg';
export const addCircleIconBlack = 'assets/icons/plus-circle-black.svg';

export const removeCircleIconWhite = 'assets/icons/remove-circle-icon.svg';
export const percentageIconBlack = 'assets/icons/percentage-icon.svg';
export const redTrashIcon = 'assets/icons/red-trash.svg';
export const grayTrashIcon = 'assets/icons/gray-trash.svg'
export const blackIconCheck = 'assets/icons/tuiIconCheck.svg';
export const columnBlackIcon = 'assets/icons/column-icon.svg';
export const grayInfoIcon = 'assets/icons/gray-info-icon.svg';
export const plusBlackIcon = 'assets/icons/plus-black.svg';
export const pencilOutlineIcon = 'assets/icons/pencil-outline.svg';
export const groupIcon = 'assets/icons/group-icon.svg';
export const searchIcon = 'assets/icons/search-icon.svg';

export const lucideIcon = 'assets/icons/lucide-info.svg'
export const additionalProduct = 'assets/icons/additional-product.svg'